import { render, staticRenderFns } from "./CustomFastFacter.vue?vue&type=template&id=dbcdfcec&"
import script from "./CustomFastFacter.vue?vue&type=script&lang=js&"
export * from "./CustomFastFacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports